import React, { useCallback, useEffect, useState } from 'react'
import { SelectInput, SelectInputProps, useRecordContext, useTranslate } from 'react-admin'
import _ from 'lodash'
import { Grid, Stack } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import dayjs from 'dayjs'
import { BRANCHCONFIG_FIELDS } from '../../../providers/localization/constant'
import { branchConfigTimeConverter } from '../../../utils/times'
import { Validator } from 'ra-core/src/form/validate'

export interface TimeStepInputProps {
  source: string
  disabled?: boolean
  validate?: Validator | Validator[]
}

export const TimeStepInput: React.FC<SelectInputProps> = ({
  source,
  disabled = false,
  validate,
}) => {
  const { setValue } = useFormContext()
  const record = useRecordContext()
  const t = useTranslate()
  const nowTime = dayjs().startOf('hour').format('HH:mm')
  const sourceValue = _.get(record, source)
  const [h, m] = sourceValue
    ? branchConfigTimeConverter(sourceValue).locale('th').format('HH:mm').split(':')
    : nowTime.split(':')
  const [hours, setHours] = useState(h)
  const [minutes, setMinutes] = useState(m)
  const renderTimeChoices = useCallback(
    (n: number, s = 1): Array<{ id: string; name: string }> =>
      [...Array(n).keys()]
        .filter((e) => e % s === 0)
        .map((i) => ({
          id: i.toString().padStart(2, '0'),
          name: i.toString().padStart(2, '0'),
        })),
    [],
  )
  useEffect(() => {
    setValue(source, `${hours}:${minutes}`)
  })
  return (
    <Stack justifyContent='center' alignItems='center' direction={'row'} spacing={3}>
      <Grid item xs={12}>
        <SelectInput
          source={`${source}_hours`}
          label={`${t(`${BRANCHCONFIG_FIELDS}.${source}`)} (${t('ra.datetime.hour')})`}
          choices={renderTimeChoices(24)}
          defaultValue={h}
          onChange={(e): void => setHours(e?.target?.value)}
          validate={validate}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <SelectInput
          source={`${source}_minutes`}
          label={`${t(`${BRANCHCONFIG_FIELDS}.${source}`)} (${t('ra.datetime.minute')})`}
          choices={renderTimeChoices(60, 15)}
          defaultValue={m}
          onChange={(e): void => setMinutes(e?.target?.value)}
          validate={validate}
          disabled={disabled}
          fullWidth
        />
      </Grid>
    </Stack>
  )
}
